"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Star = _ref => {
  let {
    title = 'Star',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.719 11.563q0 0.375-0.469 0.844l-6.469 6.313 1.531 8.938v0.375q0 0.344-0.188 0.594-0.188 0.281-0.531 0.313-0.344 0-0.719-0.219l-8.031-4.25-8 4.25q-0.375 0.219-0.719 0.219-0.375 0-0.563-0.313-0.188-0.281-0.188-0.594 0-0.125 0.031-0.375l1.531-8.938-6.5-6.313q-0.438-0.469-0.438-0.844 0-0.688 1-0.844l8.938-1.281 4.031-8.125q0.375-0.75 0.875-0.75 0.531 0 0.906 0.75l4 8.125 8.969 1.281q1 0.156 1 0.844z"
  }));
};
var _default = exports.default = (0, _ikon.default)(Star);
Star.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Star",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Star'",
        "computed": false
      },
      "required": false
    }
  }
};